import {Alert, Snackbar} from '@mui/material';
import {forced_relocation_to_login} from 'common';
import {check_token} from 'connector/fetcher';
import {useAuth} from 'hooks/userHooks';
import {Fragment, ReactNode, useEffect, useState} from 'react';

export default function ProtectedRoute(props: {children: ReactNode}) {
	const {children} = props;

	const [alert, setAlert] = useState({open: false, message: '', severity: 'warning' as 'error' | 'warning' | 'info' | 'success'});
	const {is_logged_in, relogin} = useAuth();

	useEffect(() => {
		if (!is_logged_in) {
			if (check_token()) relogin();
			else {
				setAlert({open: true, message: 'Login required', severity: 'warning'});
				forced_relocation_to_login();
			}
		}
	}, [is_logged_in]);

	return (
		<Fragment>
			{is_logged_in && children}

			<Snackbar open={alert.open} autoHideDuration={3000} onClose={() => setAlert({...alert, open: false})} anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
				<Alert onClose={() => setAlert({...alert, open: false})} severity={alert.severity} sx={{width: '100%'}}>
					{alert.message}
				</Alert>
			</Snackbar>
		</Fragment>
	);
}
